import AbstractScene from './AbstractScene.js';
import { ConcluData, IntroData } from '../consts/Data.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import ConcluItem from '../prefabs/ConcluItem.js';
import { Colors } from '../consts/Colors.js';


export default class ActiviteConclu extends AbstractScene {
    constructor() {
        super({
            key: "ActiviteConclu"
        })
    }
    init(data) {
        this._init(data);
        this.sceneData = ConcluData;
        this.introData = IntroData;
        this.screenIndex = 1;
        this.buttons = []
        this.elements = []
    }

    preload() {
        this._preload();
    }

    create() {
        this.addBackgroundMusique('minimal')
        this.addHeader("CONCLUSION ; LE PARCOURS DE RÉTABLISSEMENT");
    }

    launchScene() {
        this.title = this.createTextElement(110, 190, this.sceneData.screen1.title);
        this.nextBtn = new ButtonImageSliced(this, 1710, 990, 320, 80, "bouton", "Suivant").setDepth(10);
        this.buttons.push(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.screenIndex++;
            this.screenOut()
        })

        this.prevBtn = new ButtonImageSliced(this, 220, 990, 320, 80, "bouton", "Précédent").setDepth(10);
        this.buttons.push(this.prevBtn);
        this.prevBtn.setClickFunction(() => {
            this.screenIndex--;
            this.screenOut()
        })
        this.navBtnsGestion();
        this.buildScreen(this.screenIndex)
    }

    navBtnsGestion() {
        if (this.screenIndex === 1) {
            this.prevBtn.setAlpha(0)
        } else if (this.screenIndex === 4) {
            this.nextBtn.setLocked()
        } else if (this.screenIndex === 6) {
            this.nextBtn.destroy();
            this.prevBtn.destroy();
            this.nextBtn = new ButtonImageSliced(this, 1710, 990, 320, 80, "bouton", "Retour au menu")
            this.nextBtn.setClickFunction(() => {
                this.scene.start('Menu');
            })
        } else {
            this.prevBtn.setAlpha(1)
        }
    }

    buildScreen(i) {
        this.elements = []
        this.navBtnsGestion();
        if (i === 6) {
            this.title.destroy();
            this.endItems = []
            this.screenContainer = this.add.container(0, 0);
            let rec3 = this.add.rectangle(-1920, 0, 1920, 200, Colors.Elmt.lightBlue).setOrigin(0)
            let rec2 = this.add.rectangle(-1724, 0, 1724, 200, Colors.Elmt.MidBlue).setOrigin(0)
            let rec1 = this.add.rectangle(-1530, 0, 1530, 200, Colors.Elmt.MainBlue).setOrigin(0)
            this.screenContainer.add([rec3, rec2, rec1]);

            this.endItems.push(rec3);
            this.endItems.push(rec2);
            this.endItems.push(rec1);

            this.tweens.add({
                targets: rec3,
                x: 0,
                duration: 500,
                onComplete: () => {
                    this.tweens.add({
                        targets: rec2,
                        x: 0,
                        duration: 500,
                        onComplete: () => {
                            this.tweens.add({
                                targets: rec1,
                                x: 0,
                                duration: 500,
                                onComplete: () => {
                                    this.title = this.createTextElement(107, 80, this.sceneData['screen' + i].title);
                                    this.elements.push(this.title);
                                    this.subtitle = this.createTextElement(107, 302, this.sceneData['screen' + i].subtitle);
                                    this.elements.push(this.subtitle);
                                    this.content = this.createTextElement(107, 402, this.sceneData['screen' + i].content);
                                    this.elements.push(this.content);

                                    this.illu = this.add.image(1260, 675, 'concluEndFull').setOrigin(0.5);
                                    this.elements.push(this.illu);


                                    this.creditsBtn = this.add.text(1780, 900, "Crédits", {
                                        fontFamily: 'CenturyGothic',
                                        fontSize: '36px',
                                        color: Colors.Text.Black
                                    }).setOrigin(0.5);
                                    this.elements.push(this.creditsBtn);
                                    this.creditsBtn.setInteractive({ useHandCursor: true });
                                    this.creditsBtn.on('pointerdown', () => {
                                        this.showPopupCreditsEnd();
                                    });

                                    this.screenContainer.add([this.title, this.subtitle, this.content]);
                                    this.screenIn();
                                }
                            })
                        }
                    })
                }
            })


        } else {
            this.screenData = this.sceneData['screen' + i];
            this.screenContainer = this.add.container(0, 0);
            this.subtitle = this.createTextElement(110, 280, this.screenData.subtitle);
            this.elements.push(this.subtitle);
            this.screenContainer.add(this.subtitle);
            if (this.screenIndex !== 4) {
                this.content = this.createTextElement(960, 350, this.screenData.content);
                this.elements.push(this.content);
                this.screenContainer.add(this.content);

                for (let i = 0; i < this.screenData.illu.length; i++) {
                    const illuData = this.screenData.illu[i];
                    const illu = this.add.image(illuData.imgX, illuData.imgY, illuData.img).setOrigin(0.5)
                    this.screenContainer.add(illu)
                    this.elements.push(illu);
                }
            }
            if (this.screenIndex === 4) {
                this.items = [];
                for (let i = 0; i < this.sceneData.screen4.items.length; i++) {
                    let item = new ConcluItem(this, 310 + i * 420, i)
                    this.items.push(item)
                    this.elements.push(item);
                }
                this.screenContainer.add(this.items);
                this.consigne = this.createTextElement(110, 350, this.sceneData.screen4.consigne);
                this.elements.push(this.consigne);
                this.screenContainer.add(this.consigne);
            }
            if (this.screenIndex === 5) {
                this.content.x = 107
                this.content.y = 402
            }
            this.screenIn();
        }


    }

    screenOut() {
        this.elements = this.elements.reverse();
        this.elements.forEach(el => {
            this.tweens.add({
                targets: el,
                alpha: 0,
                duration: 100,
                delay: 50 * this.elements.indexOf(el),
                onComplete: () => {
                    if (this.elements.indexOf(el) === this.elements.length - 1) {
                        if (this.items) {
                            this.items.forEach(item => {
                                if (item && item.scene) {
                                    item.removeAllListeners();
                                }
                            });
                            this.items = null;
                        }
                        this.screenContainer.destroy();
                        this.buildScreen(this.screenIndex);
                    }
                }
            });
        })
    }

    screenIn() {
        this.elements.forEach(el => {
            el.setAlpha(0);
            this.tweens.add({
                targets: el,
                alpha: 1,
                duration: 300,
                delay: 100 * this.elements.indexOf(el)
            });
        })
    }

    showPopupCreditsEnd() {
        this.blur = this.add.rectangle(0, 0, this.width, this.height, 0xffffff, 0.55).setOrigin(0)
        this.creditsContainer = this.add.container(0, 1020);
        let popupBg = this.add.rexRoundRectangle(this.width / 2, this.height / 2, 1610, 860, 20, Colors.Elmt.MainBlue).setAlpha(1);
        this.creditsContainer.add(popupBg);

        let closeBtn = this.add.text(this.width / 2 + 750, this.height / 2 - 400, "X", {
            fontFamily: 'CenturyGothicBold',
            fontSize: '48px',
            color: Colors.Text.White
        }).setOrigin(0.5);
        closeBtn.setInteractive({ useHandCursor: true });
        closeBtn.on('pointerdown', () => {
            this.tweens.add({
                targets: this.creditsContainer,
                y: 1020,
                duration: 300,
                onComplete: () => { 
                    this.blur.destroy();
                    this.creditsContainer.destroy();

                }
            })
        });
        this.creditsContainer.add(closeBtn);

        this.line1 = this.createTextElement(210, 155, this.introData.line1);
        this.line2 = this.createTextElement(210, 400, this.introData.line2);
        this.line3 = this.createTextElement(this.width / 2, 855, this.introData.line3);
        this.creditsContainer.add(this.line1);
        this.creditsContainer.add(this.line2);
        this.creditsContainer.add(this.line3);

        for (let i = 0; i < this.introData.items.length; i++) {
            const el = this.introData.items[i];
            let itemText = this.createTextElement(702, 180 + el.suppY, el.content);
            this.creditsContainer.add(itemText);
            let itemLogo = this.add.image(655, el.logoY, el.logo).setOrigin(1, 0.5)
            this.creditsContainer.add(itemLogo);
            this.creditsContainer.add(itemText);
        }

        this.tweens.add({
            targets: this.creditsContainer,
            y: 0,
            duration: 300,
        })


    }
}